import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { DcFileDTO } from 'src/app/shared/models/dc-file-dto.model';
import { TemplateFile } from 'src/app/shared/models/template-file.model';
import { BehaviorSubject } from 'rxjs';

const API_GET_ALL_TEMPLATE_FILE = '/dc/template-files/get-all';
const API_SAVE_ALL_TEMPLATE_FILE = '/dc/template-files/save-all';
const API_DELETE_TEMPLATE_FILE = '/dc/template-files/delete-all';

const API_SAVE_FILE = '/dc/files/save-all';
const API_GET_CONTENT_BY_URL = '/dc/files/get-content-by-url';
const API_CONVERT_DOCX_TO_PDF = '/dc/files/convert-docx-to-pdf';
const API_GET_CONTENT_TEMPLATE_BY_URL = '/dc/files/get-content-template-by-url';

const API_SYSTEM_GET_ALL_TEMPLATE_FILE = '/dc/template-files/system-get-all';

@Injectable({
    providedIn: 'root'
})
export class TemplateFileService {
    currentLanguage: BehaviorSubject<string>;
    constructor(private apiService: ApiService) { }

    getTemplateFile(templateId: number) {
        return this.apiService.get(`${API_GET_ALL_TEMPLATE_FILE}?templateId=${templateId}`)
            .pipe(map(res => {
                return res;
            }));
    }

    saveTemplateFile(body: Array<TemplateFile>) {
        return this.apiService.post(API_SAVE_ALL_TEMPLATE_FILE, body)
            .pipe(map(res => {
                return res;
            }));
    }

    deleteTemplateFile(ids: Array<number>) {
        return this.apiService.post(API_DELETE_TEMPLATE_FILE, ids)
            .pipe(map(res => {
                return res;
            }));
    } 


    saveFile(templateId: number, body: Array<DcFileDTO>) {
        return this.apiService.post(`${API_SAVE_FILE}?templateId=${templateId}`, body)
            .pipe(map(res => {
                return res;
            }));
    }

    getContentFileByUrl(body: { type: string, url: string }) {
        return this.apiService.getFilePostMethod(API_GET_CONTENT_BY_URL, body)
            .pipe(map(res => {
                return res
            }));
    }

    convertDocxToPdf(body: { url: string }) {
        return this.apiService.getFilePostMethod(API_CONVERT_DOCX_TO_PDF, body)
            .pipe(map(res => {
                return res
            }));
    }

    getContentTemplateFileByUrl(body: { type: string, url: string }) {
        return this.apiService.getFilePostMethod(API_GET_CONTENT_TEMPLATE_BY_URL, body)
            .pipe(map(res => {
                return res
            }));
    }

    getSystemTemplateFile(templateId: number) {
        return this.apiService.get(`${API_SYSTEM_GET_ALL_TEMPLATE_FILE}?templateId=${templateId}`)
            .pipe(map(res => {
                return res;
            }));
    }
}
